// extracted by mini-css-extract-plugin
export default {"footer":"Rodape_footer__DuPYD"};